import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const NATION_DIAL = {
  Italia: "39", Germania: "49", Francia: "33", Spagna: "34", "Regno Unito": "44",
  Austria: "43", Svizzera: "41", "Paesi Bassi": "31", Belgio: "32", Portogallo: "351",
  Slovenia: "386", Croazia: "385", "Stati Uniti": "1",
};

// Normalizza un numero in E.164 (+<cc><numero>). Mirror della logica backend.
// Rimuove spazi/trattini/caratteri non numerici; per i numeri italiani senza
// prefisso aggiunge automaticamente +39. Restituisce "" se non normalizzabile.
export function normalizePhoneE164(input, nation = "Italia") {
  const raw = (input || "").trim();
  if (!raw) return "";
  const hasPlus = raw.startsWith("+");
  let digits = raw.replace(/\D/g, "");
  if (!digits) return "";
  if (hasPlus) return digits.length >= 8 ? `+${digits}` : "";
  if (digits.startsWith("00")) {
    digits = digits.slice(2);
    return digits.length >= 8 ? `+${digits}` : "";
  }
  const cc = NATION_DIAL[nation] || "39";
  if (digits.startsWith(cc) && digits.length >= cc.length + 9) return `+${digits}`;
  if (nation !== "Italia" && digits.startsWith("0")) digits = digits.slice(1);
  if (digits.length < 5) return "";
  return `+${cc}${digits}`;
}
